import { Engine } from 'engine/Engine';
import { Facet } from 'engine/facets/Facet';
import { UIFacet } from 'engine/facets/UIFacet';
import { create } from 'engine/lib/create';
import { createElement } from 'react';
import { Dialog } from './Dialog';
import { DialogMessage } from './DialogMessage';

const uiFacet = create(UIFacet, { Component: () => null });

export class DialogMode extends Facet {

  enter(messages: DialogMessage[], engine: Engine) {
    engine.time.timeScale = 0;
    const exit = () => this.exit(engine);
    uiFacet.props.Component = () => createElement(Dialog, { messages, exit });
    this.entity.addFacet(uiFacet, engine);
  }

  exit(engine: Engine) {
    this.entity.removeFacet(uiFacet);
    engine.time.timeScale = 1;
  }
}
